<div class="ui-g">
  <div class="ui-g-12">{{headerStr}}</div>
  <div class="ui-g-9">
    <p-chart height="100" type="bar" [data]="buildData" [options]="options"></p-chart>
  </div>
  <div class="ui-g-3">
    <label translate>label_month</label>
    <p-select [options]="monthList" [(ngModel)]="selectedMonth" (onChange)="refreshData()">
    </p-select>
    <label translate>label_year</label>
    <p-select [options]="yearList" [(ngModel)]="selectedYear" (onChange)="refreshData()">
      </p-select>
    </div>
</div>
